<template>
	<div id="app" v-hotkey="keymap">
		<div v-if="user!=''&&user!=undefined&&user!=null" class="menu">
			<div class="tabs">

				<div class="dropdown">
					<button tabindex="-1" v-on:click="toggleDropdown('1')" class="dropbtn">File<font-awesome-icon class="arrow" icon="chevron-down"/></button>
					<div id="drp_1" class="dropdown-content">

						<a href="#/home" v-on:click="removeDropdowns">Home</a>
						<hr/>
						<a v-if="user!=''&&user!=undefined&&user!=null" target="_blank" href="https://accounts.ldpa.com/realms/master/account" v-on:click="removeDropdowns">Account</a>
						<a href="#/0201" v-on:click="removeDropdowns">Signup</a>
						<a href="#/0200" v-on:click="removeDropdowns">Login</a>
						<a href="javascript:;" v-on:click="logout()">Logout</a>
						<hr/>
						<a v-if="perms.includes('103')" href="#/0208" v-on:click="removeDropdowns">Permissions</a>
						<a v-if="perms.includes('85')" href="#/0207" v-on:click="removeDropdowns">Logs</a>
						<a href="#/0206" v-on:click="removeDropdowns">LDPA Cloud</a>
						<hr/>
						<a v-if="perms.includes('100')" href="#/0412" v-on:click="removeDropdowns">Submit Troubleticket</a>
						<hr/>
						<a v-if="perms.includes('87')" href="#/downloadapp" v-on:click="removeDropdowns">Download Mobile App</a>
						<a v-if="perms.includes('96')" href="#/downloadcandidateapp" v-on:click="removeDropdowns">Download App Candidate</a>

					</div>
				</div>

				<div class="dropdown">
					<button tabindex="-1" v-on:click="toggleDropdown('2')" class="dropbtn">Job Orders<font-awesome-icon class="arrow" icon="chevron-down"/></button>
					<div id="drp_2" class="dropdown-content">

						<a v-if="perms.includes('1')" href="#/0300" v-on:click="removeDropdowns">Job Orders</a>
						<a v-if="perms.includes('44')" href="#/0310" v-on:click="removeDropdowns">Scheduling</a>
						<a v-if="perms.includes('120')" href="#/0329" v-on:click="removeDropdowns">Scheduling V2</a>
						<a v-if="perms.includes('1')" href="#/0318" v-on:click="removeDropdowns">Port Stays</a>
						<a v-if="perms.includes('134')" href="#/0334" v-on:click="removeDropdowns">Trips</a>
						<hr/>
						<a v-if="perms.includes('18')" href="#/0305" v-on:click="removeDropdowns">Vessels</a>
						<a v-if="perms.includes('55')" href="#/0311" v-on:click="removeDropdowns">Vessel History</a>
						<hr/>
						<a v-if="perms.includes('4')" href="#/0303" v-on:click="removeDropdowns">Unassigned Documents</a>
						<a v-if="perms.includes('132')" href="#/0332" v-on:click="removeDropdowns">Assign Document WO</a>
						<a v-if="perms.includes('132')" href="#/0335" v-on:click="removeDropdowns">Approve Documents</a>
						<hr/>
						<a v-if="perms.includes('14')" href="#/0400" v-on:click="removeDropdowns">Add Job Order</a>
						<a v-if="perms.includes('31')" href="#/0401" v-on:click="removeDropdowns">Add Vessel</a>
						<a v-if="perms.includes('34')" href="#/0402" v-on:click="removeDropdowns">Add Document</a>

					</div>
				</div>

				<div class="dropdown">
					<button tabindex="-1" v-on:click="toggleDropdown('3')" class="dropbtn">Invoicing<font-awesome-icon class="arrow" icon="chevron-down"/></button>
					<div id="drp_3" class="dropdown-content">

						<a v-if="perms.includes('40')" href="#/0308" v-on:click="removeDropdowns">Invoices</a>
						<a v-if="perms.includes('77')" href="#/0317" v-on:click="removeDropdowns">Invoice Status</a>
						<a v-if="perms.includes('70')" href="#/0315" v-on:click="removeDropdowns">PO Numbers</a>
						<a v-if="perms.includes('83')" href="#/0319" v-on:click="removeDropdowns">Contracts</a>
						<hr/>
						<a v-if="perms.includes('72')" href="#/0407" v-on:click="removeDropdowns">Add PO Number</a>

					</div>
				</div>

				<div class="dropdown">
					<button tabindex="-1" v-on:click="toggleDropdown('4')" class="dropbtn">Times<font-awesome-icon class="arrow" icon="chevron-down"/></button>
					<div id="drp_4" class="dropdown-content">

						<a v-if="perms.includes('33')" href="#/0307" v-on:click="removeDropdowns">Employee Overview</a>
						<a v-if="perms.includes('3')" href="#/0302" v-on:click="removeDropdowns">Employee Hours</a>
						<hr/>
						<a v-if="perms.includes('99')" href="#/0326" v-on:click="removeDropdowns">Timesheets</a>
						<a v-if="perms.includes('99')" href="#/0330" v-on:click="removeDropdowns">Map</a>
						<hr/>
                        <a v-if="perms.includes('131')" href="#/0331" v-on:click="removeDropdowns">Edit Employees</a>

					</div>
				</div>

				<div class="dropdown">
					<button tabindex="-1" v-on:click="toggleDropdown('5')" class="dropbtn">Inventory<font-awesome-icon class="arrow" icon="chevron-down"/></button>
					<div id="drp_5" class="dropdown-content">

						<a v-if="perms.includes('88')" href="#/0322" v-on:click="removeDropdowns">Inventory</a>
						<a v-if="perms.includes('88')" href="#/0325" v-on:click="removeDropdowns">Boxes</a>
						<a v-if="perms.includes('88')" href="#/0333" v-on:click="removeDropdowns">Edit Box Items</a>
						<hr/>
						<a v-if="perms.includes('89')" href="#/0410" v-on:click="removeDropdowns">Add Inventory Item</a>

					</div>
				</div>

				<div class="dropdown">
					<button tabindex="-1" v-on:click="toggleDropdown('6')" class="dropbtn">Reports<font-awesome-icon class="arrow" icon="chevron-down"/></button>
					<div id="drp_6" class="dropdown-content">
						<div v-if="perms.includes('86')" class="dropdowngroup">
							<a v-on:click="toggleDropdown('8', '6')" href="javascript:;">Dashboards<font-awesome-icon class="arrow" icon="chevron-right"/></a>
							<div id="drp_8" class="dropdowngroup-content">
								<a v-for="(dashboard,index) in dashboards" v-on:click="removeDropdowns" :href="'#/0321?q='+(index+1)">{{dashboard}}</a>
							</div>
						</div>
						<a v-if="perms.includes('79')" href="#/0600" v-on:click="removeDropdowns">Custom</a>
						<div v-if="perms.includes('78')" class="dropdowngroup">
							<a v-on:click="toggleDropdown('7', '6')" href="javascript:;">Status<font-awesome-icon class="arrow" icon="chevron-right"/></a>
							<div id="drp_7" class="dropdowngroup-content">
								<a v-for="(statusgroup,index) in statusgroups" v-on:click="setStatusGroup(index+1)" href="#/0601">{{statusgroup}}</a>
							</div>
						</div>
					</div>
				</div>

				<div class="dropdown">
					<button tabindex="-1" v-on:click="toggleDropdown('9')" class="dropbtn">Tools<font-awesome-icon class="arrow" icon="chevron-down"/></button>
					<div id="drp_9" class="dropdown-content">

						<a v-if="perms.includes('1')" href="#/0700" v-on:click="removeDropdowns">Proxy Test</a>
						<a v-if="perms.includes('114')" href="#/0701" v-on:click="removeDropdowns">Emails</a>
						<a v-if="perms.includes('117')" href="#/0328" v-on:click="removeDropdowns">Website HTML</a>

					</div>
				</div>

				<p class="page-name">{{$route.name}}</p>
			</div>
			<p v-if="user!=''&&user!=undefined&&user!=null" class="logged" v-on:click="navigate('0205')">Logged in as {{user}}</p>
		</div>

		<router-view></router-view>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
import main from '@/main'
import {PAGES} from './../constants.js'
export default {
	perms:[],
	name: 'app',
	data() {
		return {
			user:'',
			statusgroups:[],
			dashboards:[],
			pageid1:PAGES.STATUS_GROUP_PAGE,
			pageid2:PAGES.DASHBOARDS_GROUP_PAGE,
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.updateUser();
		this.setColor();
		this.getStatusGroups();
		this.getDashboards();
		document.addEventListener('click', this.handleOutsideClick);

        let rerouteList = ["/0200", "/0201", "/0202", "/0203",  "/0204", ]
		if(this.$route.path == "/") {
            router.push('/home')
        }else if((this.user==''||this.user==undefined||this.user==null) && !rerouteList.includes(this.$route.path)){
			router.push('/home')
		}
	},
	computed: {
		keymap() {
			return {
				"ctrl+e": this.openScanner,
			};
		}
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleOutsideClick);
	},
	methods:{
		handleOutsideClick(event) {
			if (!event.target.closest('.dropdown')) {
				this.removeDropdowns();
			}
		},
		openScanner(){
			if(this.$route.path != "/0511" && this.$route.path != "/0333"){
				router.push('/0411');
			}
		},
		toggleDropdown(id, parentId){
			const className = 'dropdownToggle';

			this.removeDropdowns(id);
			var element = document.getElementById('drp_'+id);
			element.classList.toggle(className);

			var checkToggle = element.classList.contains(className)
			if(parentId != null){
				var parentElement = document.getElementById('drp_'+parentId);
				parentElement.classList.add(className);
			}
		},
		removeDropdowns(exclude){
			const className = 'dropdownToggle';

			var elements = document.querySelectorAll('*[id^="drp_"]');
			for(let i = 0;i<elements.length;i++){
				if(exclude==null || elements[i].id!='drp_'+exclude){
					elements[i].classList.remove(className);
				}
			}

		},
		getStatusGroups(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid1
					}
				}
			).then((res) => {
				for(let i = 0;i<res.data.data.column_data.length;i++){
				   this.statusgroups.push(res.data.data.column_data[i][0]);
				}
			});
			this.removeDropdowns();
		},
		getDashboards(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid2
					}
				}
			).then((res) => {
				for(let i = 0;i<res.data.data.column_data.length;i++){
				   this.dashboards.push(res.data.data.column_data[i][0]);
				}
			});
			this.removeDropdowns();
		},
		setStatusGroup(index){
			document.cookie="statusGroup="+index+";";
			router.push('/0601');
			router.go();
		},
		logout(){
			api.eraseLogCookies();
			router.push('/home');
			this.user = '';
			this.removeDropdowns();
		},
		updateUser(){
			this.user=api.getCookie("user");
		},
		setColor(timer){
			let stateCheck = setInterval(() => {
				if (document.readyState=="complete") {
					clearInterval(stateCheck);
					api.setWOColors()
				}
			}, timer);
		},
		navigate(path){
			router.push(path)
		}
	},
	watch:{
		$route() {
			this.setColor(100)
		},
	}
}
</script>

<style>
body {
	margin: 0;
}

#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}

main {
	text-align: center;
	margin-top: 40px;
}

header {
	margin: 0;
	height: 55px;
	padding: 0 16px 0 24px;
	background-color: #35495E;
	color: #ffffff;
}

header span {
	display: block;
	position: relative;
	font-size: 20px;
	line-height: 1;
	letter-spacing: .02em;
	font-weight: 400;
	box-sizing: border-box;
	padding-top: 16px;
}

.menu {
	background:#35495E;
    height:50px;
}

.login {
	position:absolute;
	top:5px;
	right:5px;
	text-decoration: underline;
}

.tabs{
	display:inline-block;
}

.page-name{
	position:relative;
	display:inline-block;
	text-align:center;
	font-weight: bold;
	font-size: 20px;
	color:#ffffff;
	height:40px;
	min-width:200px;
	margin:5px;
	padding:2.5px 10px;
	border:2px solid #212529;
	border-radius: 3px;
	background: #212529;
	background: radial-gradient(circle, #35495E 75%, #212529 100%);
}

.logged{
	position:absolute;
	color:#ffffff;
	height:40px;
	padding:5px;
	margin:5px;
	top:0px;
	right:0px;
	border:2px solid #212529;
	border-radius: 3px;
	background: #212529;
	background: radial-gradient(circle, #35495E 75%, #212529 100%);
	cursor: pointer;
}
/*------------------------------------------------------------------------------*/
.dropbtn {
	background-color: #343a40;
	color: white;
	padding:6px 32px 6px 16px;
	font-size: 16px;
	border: none;
	cursor: pointer;

}
.dropdown {
	position: relative;
	display: inline-block;
	float:left;
	margin:5px 0px 0px 5px;
	z-index: 10;
}
.dropdown-content, .dropdowngroup-content {
	display: none;
	position: absolute;
	background-color: #f9f9f9;
	width: 200px;
	box-shadow: 0px 16px 16px 0px rgba(0,0,0,0.2);
	z-index: 9;
}
.dropdown-content a, .dropdowngroup-content a {
	color: black;
	padding: 8px;
	text-decoration: none;
	display: block;
}
.dropdown-content a:hover, .dropdowngroup-content a:hover {
	background-color: #f1f1f1;
}
.dropdown-content hr {
	margin:2px 0px 2px 0px;
}
/*.dropdown:hover .dropdown-content, .dropdowngroup:hover .dropdowngroup-content {
	display: block;
}*/
.dropdownToggle {
	display: block;
}
.dropdown:hover .dropbtn {
	background-color: #212529;
}
/*------------------------------------------------------------------------------*/
.dropdowngroup {
	position: relative;
    display: block;
}
.dropdowngroup-content {
	left:200px;
	top:0px;
}
.arrow{
	font-size:14px;
	margin: 0px 10px 0px 0px;
	position: absolute;
	top:50%;
	right:0px;
	transform: translateY(-50%);
}
/*------------------------------------------------------------------------------*/
</style>



// WEBPACK FOOTER //
// src/App.vue